import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Bot, Calendar, Cpu, Database } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { listPavilionAgentsQueryOptions } from "../../lib/hooks/usePavilionAgents";

export const Route = createFileRoute("/(pavilion)/pavilion/")({
  component: PavilionIndex,
});

function PavilionIndex() {
  const navigate = useNavigate();

  // Fetch agents using TanStack Query
  const { data: agentsResponse } = useQuery(listPavilionAgentsQueryOptions());
  const agents = agentsResponse?.data?.agents || [];

  return (
    <div className="flex-1 p-6 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-medium mb-2">Agents Overview</h1>
          <p className="text-muted-foreground text-sm">
            Manage and monitor your AI agents
          </p>
        </div>

        <div className="rounded-xl border bg-card shadow-sm">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="font-medium text-sm">Agent</TableHead>
                <TableHead className="font-medium text-sm">Model</TableHead>
                <TableHead className="font-medium text-sm">Created</TableHead>
                <TableHead className="font-medium text-sm">Last Used</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {agents?.map((agent) => (
                <TableRow
                  key={agent.id}
                  className="cursor-pointer hover:bg-muted/50 transition-colors duration-200"
                  onClick={() =>
                    navigate({
                      to: "/pavilion/$agentName",
                      params: { agentName: agent.name },
                      search: { leftTab: "system", rightTab: "console" },
                    })
                  }
                >
                  <TableCell className="p-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                        <Bot className="h-4 w-4" />
                      </div>
                      <div className="min-w-0">
                        <div className="font-medium truncate">{agent.name}</div>
                        <div className="text-sm text-muted-foreground truncate">
                          {agent.description || "AI Assistant"}
                        </div>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="p-4">
                    <div className="flex items-center gap-2">
                      <Cpu className="h-3.5 w-3.5 text-muted-foreground" />
                      <span className="font-mono text-sm">
                        {agent.modelProvider}/{agent.modelName}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell className="p-4">
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Calendar className="h-3.5 w-3.5" />
                      {new Date(agent.createdAt).toLocaleDateString()}
                    </div>
                  </TableCell>
                  <TableCell className="p-4">
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Database className="h-3.5 w-3.5" />
                      {new Date(agent.updatedAt).toLocaleDateString()}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
